import React from "react";
import { AiOutlineQuestionCircle } from "react-icons/ai"; // Question Icon

 const MoveToTrendingPopup = ({ isOpen, onClose, onConfirm, onSelectedAction }) => {
  if (!isOpen) return null; // Prevent rendering when closed

  const handleConfirm = async () => {
    try {
      await onConfirm(); // Call the provided function
      onClose(); // Close modal after confirmation
    } catch (error) {
      console.error("Error moving to trending:", error);
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div className="bg-white rounded-lg p-6 w-[400px] text-center shadow-lg">
        {/* Icon */}
        <div className="flex justify-center mb-3">
          <AiOutlineQuestionCircle className="text-red-500 text-6xl" />
        </div>

        {/* Message */}
        <p className="text-gray-700 font-medium text-lg">
          {onSelectedAction === 'Trending' ? 'Are you sure you want to move these products to Trending Products?' : 
          'Are you sure you want to remove these products From Trending Products?'}
        </p>

        {/* Buttons */}
        <div className="flex justify-center gap-4 mt-4">
          <button 
            className="px-6 py-2 border border-red-500 text-red-500 rounded-md hover:bg-red-100"
            onClick={onClose}
          >
            No
          </button>
          <button 
            className="px-6 py-2 bg-red-500 text-white rounded-md hover:bg-red-600"
            onClick={handleConfirm}
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default MoveToTrendingPopup;